// Moves an open tab onto a newly deployed frontend without interrupting the user: once the new
// service worker has taken over, the next page change does a full reload instead.
let updateReady = false;

export const watchForAppUpdate = (): void => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const { serviceWorker } = navigator;
  // The very first install also fires controllerchange; only a replaced worker is an update.
  let hasController = Boolean(serviceWorker.controller);
  serviceWorker.addEventListener('controllerchange', () => {
    updateReady = hasController;
    hasController = true;
  });
};

// Called on every page change. Reloads when a new version has taken over; otherwise asks the
// browser to look for one, because on its own it does so only on a full page load.
export const reloadOrCheckForAppUpdate = (): void => {
  if (updateReady) {
    window.location.reload();
    return;
  }
  if (!('serviceWorker' in navigator)) {
    return;
  }

  navigator.serviceWorker
    .getRegistration()
    .then((registration) => registration?.update())
    .catch(() => undefined);
};
